import { useState } from 'react';
import { DAY_WIDTHS } from '../utils/ganttDates';
import useZoomKeepsCentre from './useZoomKeepsCentre';

/**
 * useGanttZoom(scrollRef) → { zoom, dayWidth, zoomTo, applyCentre }
 *
 * THE zoom state of a Gantt chart: which of Week / Month / Quarter is showing,
 * how many pixels a day is at that zoom, and the rule for changing it. Every
 * chart used to hold its own `useState('month')`, two of them their own copy of
 * the pixels-per-day table, and each wired `useZoomKeepsCentre` by hand (owner
 * 2026-10-13: "make sure we use common code and modules for the gantt charts
 * where possible").
 *
 *   zoom        'week' | 'month' | 'quarter'; opens on 'month', and is session
 *               state on purpose: no chart stores a zoom
 *   dayWidth    `utils/ganttDates#DAY_WIDTHS[zoom]`, the ONE table
 *   zoomTo(z)   what the zoom buttons call (`gantt/GanttZoomControl`); it keeps
 *               the date in the middle of the view. There is deliberately no
 *               bare `setZoom` to reach for.
 *   applyCentre the chart's "position the scroll" effect calls it first; see
 *               `useZoomKeepsCentre` for the contract.
 *
 * `scrollRef` is the chart's horizontal scroller. Display only.
 */
export default function useGanttZoom(scrollRef) {
  const [zoom, setZoom] = useState('month');
  const dayWidth = DAY_WIDTHS[zoom] || DAY_WIDTHS.month;
  const { zoomTo, applyCentre } = useZoomKeepsCentre(scrollRef, zoom, dayWidth, setZoom);
  return { zoom, dayWidth, zoomTo, applyCentre };
}
